import { Section } from 'app/models/types';
import { FieldNames } from 'app/models/fields/names';
import { LoanOfficerCondition } from 'app/models/fields/conditionals';
import {
  REVERSE_ADVISOR_STOP_GATE,
  REVERSE_LEAD_ONLY_COBORROWER_PERSONAL_INFORMATION,
  REVERSE_LEAD_ONLY_LOAN_GOAL,
  REVERSE_LEAD_ONLY_PERSONAL_INFO,
  REVERSE_LEAD_ONLY_PROPERTY_INFO,
} from './constants';
import { reverseLeadOnlyQuestionsByName } from '../questions/reverse-lead-only';
import { FormParagraphs } from 'app/models/paragraphs';
import { handleReverseShortFormSubmit } from 'app/actions/form/reverse-mortgage/actions';
import { ReverseAdvisorStopGate } from 'app/components/Reverse/ReverseAdvisorStopGate';
import { ConsentToContact } from 'app/components/Disclaimer/ConsentToContact';

export const getReverseLeadOnlySectionById = (id: number): Section => {
  return REVERSE_LEAD_ONLY_SECTIONS.find((section) => section.id === id) as Section;
};

const REVERSE_LEAD_ONLY_SECTIONS: Section[] = [
  {
    id: REVERSE_LEAD_ONLY_LOAN_GOAL,
    questions: reverseLeadOnlyQuestionsByName([FieldNames.reverseMortgageLoanPurpose]),
  },
  {
    id: REVERSE_LEAD_ONLY_PERSONAL_INFO,
    title: 'Enter your information',
    agreement : <ConsentToContact />,
    paragraph : FormParagraphs.reverseMortgageVerbiage,
    questions: reverseLeadOnlyQuestionsByName([
      FieldNames.firstName,
      FieldNames.lastName,
      FieldNames.email,
      FieldNames.phone,
      FieldNames.dateOfBirth,
      FieldNames.age,
    ]),
    conditionalIf : {
      referToLoIf : [LoanOfficerCondition.isBorrowerTooYoung],
    },
  },
  {
    id: REVERSE_LEAD_ONLY_COBORROWER_PERSONAL_INFORMATION,
    questions: reverseLeadOnlyQuestionsByName([
      FieldNames.coBorrowerYN,
      FieldNames.coBorrowerFirstName,
      FieldNames.coBorrowerLastName,
      FieldNames.coBorrowerDOB,
      FieldNames.coBorrowerAge,
    ]),
    conditionalIf : {
      referToLoIf : [LoanOfficerCondition.isCoBorrowerTooYoung],
    },
  },
  {
    id: REVERSE_LEAD_ONLY_PROPERTY_INFO,
    questions: reverseLeadOnlyQuestionsByName([
      FieldNames.livingPropertyState,
      FieldNames.homeValue,
      FieldNames.propertyHasMortgage,
      FieldNames.mortgageBalance,
    ]),
    submitAction: handleReverseShortFormSubmit,
  },
  {
    id: REVERSE_ADVISOR_STOP_GATE,
    ifNoQuestions: ReverseAdvisorStopGate,
    hideProgressBar: true,
  },
];
